import React from 'react';
import { Button } from 'antd';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { FormattedMessage } from 'react-intl';
import { getUserHistory } from 'actions/Users/user.history.action';
import AbstractMachine from './abstractMachine';
import userAPI from '../../../../API/user.service.api';
import {
  ACCEPT_LEGAL_ISSUES,
  START_LOGIN,
} from '../../../../constants/enter.user.constants';
import CheckLegalIssues from '../../../Utility/CheckLeggalIssues/legalIssues';
import {
  loginLegalIssuesModalOpen,
  loginIsLogin,
  loginModalOpen,
} from '../../../../actions/Login/login.action';
import { userConstants } from '../../../../constants/user.constants';
import { openNotificationWithIcon } from '../../../Utility/notificationMessage';
import userEnterStore from '../userEnter.service';

export default class acceptLegalIssues extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = ACCEPT_LEGAL_ISSUES;
  }

  getTitle = () => {
    return (
      <FormattedMessage
        id="Accept Legal Issues"
        defaultMessage="Accept Legal Issues"
      />
    );
  };

  getMessage = () => {
    return (
      <FormattedMessage
        id="Please accept Legal Issues to login"
        defaultMessage="Please accept Legal Issues to login"
      />
    );
  };

  isShowFreePro = () => {
    return false;
  };

  isSocialButtonsAllowed = () => {
    return false;
  };

  moveLegalWindowTop = (dispatch) => {
    dispatch(loginLegalIssuesModalOpen(true));
  };

  onLegalIssuesChange = () => {
    this._goTo(null, this.moveLegalWindowTop);
  };

  onSubmit = () => {
    this._form.validateFields().then((values) => {
      const { userEmail } = values;
      this._goTo(null, this.checkingEmail, userEmail);
    });
  };

  login = (dispatch, params) => {
    function success(user) {
      return { type: userConstants.LOGIN_SUCCESS, user };
    }

    userAPI
      .login(params)
      .then(
        (data) => {
          if (data.response && data.response.userdata) {
            const user = data.response.userdata;
            if (user.legal_issues) {
              userEnterStore.set(user);
              dispatch(success(user));

              dispatch(loginIsLogin(true));
              dispatch(loginModalOpen(false));
              dispatch(setStateUserEnter({ name: START_LOGIN }));
              dispatch(getUserHistory(user.id));
            } else {
              openNotificationWithIcon('warning', this.getMessage());
              dispatch(
                setStateUserEnter({ ...params, name: ACCEPT_LEGAL_ISSUES })
              );
            }
          }
        },
        (error) => {
          console.info(`acceptlegal err ${error}`);
        }
      )
      .catch((error) => console.info(`acceptlegal ${error}`));
  };

  submitLogin = ({ apiMethod, facebook_id, google_id }) => {
    this._form
      .validateFields()
      .then((values) => {
        const { userEmail, legalIssues } = values;
        const params = {
          login: userEmail,
          legalIssues: legalIssues ? 1 : 0,
          apiMethod,
        };
        if (facebook_id) params.facebook_id = facebook_id;
        if (google_id) params.google_id = google_id;

        if (userEmail) {
          this._goTo(null, this.login, params);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render(props) {
    return (
      <div className="continueDivRender">
        {this.getMainInput({ ...props, disabled: true })}
        <CheckLegalIssues
          form={this._form}
          clickHandler={this.onLegalIssuesChange}
        />
        <Button
          type="primary"
          style={{ marginTop: '11px' }}
          className="ant-btn-primary width100"
          onClick={() => this.submitLogin(props)}
        >
          <span>
            <FormattedMessage id="Continue" defaultMessage="Continue" />
          </span>
        </Button>
      </div>
    );
  }
}
